"use client";

import { useState } from "react";
import { ArrowRight } from "lucide-react";

import { LeadCaptureModal } from "@/components/lead-capture-modal";

// The hero's primary CTA. Accounts are invite-only, so "Get Started"
// opens the same inquiry form as "Book a Demo" instead of a sign-up page.
// Client wrapper so the hero itself can stay a server component.
export function GetStartedButton() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="bg-rl-accent hover:bg-rl-accent-bright inline-flex cursor-pointer items-center gap-1.5 rounded-full px-7 py-3.5 text-[0.9375rem] font-bold text-[#08090c] transition-all duration-200 hover:shadow-[0_8px_30px_-10px_oklch(0.72_0.192_161/0.5)]"
      >
        Get Started
        <ArrowRight size={15} aria-hidden />
      </button>
      <LeadCaptureModal open={open} onOpenChange={setOpen} />
    </>
  );
}
